/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Export_ButtonInputs */

const en_explorer_info_batch_export_button = /** @type {(inputs: Explorer_Info_Batch_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch Export`)
};

const fr_explorer_info_batch_export_button = /** @type {(inputs: Explorer_Info_Batch_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation par lots`)
};

const de_explorer_info_batch_export_button = /** @type {(inputs: Explorer_Info_Batch_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stapel-Export`)
};

const it_explorer_info_batch_export_button = /** @type {(inputs: Explorer_Info_Batch_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione in batch`)
};

const ru_explorer_info_batch_export_button = /** @type {(inputs: Explorer_Info_Batch_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пакетный экспорт`)
};

const es_explorer_info_batch_export_button = /** @type {(inputs: Explorer_Info_Batch_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación por lotes`)
};

const zh_cn2_explorer_info_batch_export_button = /** @type {(inputs: Explorer_Info_Batch_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量导出`)
};

const ja_explorer_info_batch_export_button = /** @type {(inputs: Explorer_Info_Batch_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バッチエクスポート`)
};

const hi_explorer_info_batch_export_button = /** @type {(inputs: Explorer_Info_Batch_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैच निर्यात`)
};

const pt_pt2_explorer_info_batch_export_button = /** @type {(inputs: Explorer_Info_Batch_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação em lote`)
};

/**
* | output |
* | --- |
* | "Batch Export" |
*
* @param {Explorer_Info_Batch_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_export_button = /** @type {((inputs?: Explorer_Info_Batch_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Export_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_batch_export_button(inputs)
	if (locale === "de") return de_explorer_info_batch_export_button(inputs)
	if (locale === "it") return it_explorer_info_batch_export_button(inputs)
	if (locale === "ru") return ru_explorer_info_batch_export_button(inputs)
	if (locale === "es") return es_explorer_info_batch_export_button(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_batch_export_button(inputs)
	if (locale === "ja") return ja_explorer_info_batch_export_button(inputs)
	if (locale === "hi") return hi_explorer_info_batch_export_button(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_batch_export_button(inputs)
	return en_explorer_info_batch_export_button(inputs)
});